function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastDelivery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.198,
    height: 23.197,
    viewBox: "0 0 39.198 23.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.944.231c3.4.789 4.7 2.776 6.328 5.511h-6.328zM8.083 5.972a1.008 1.008 0 0 1 1.148 1.071 1.148 1.148 0 0 1-1.145 1.149H1.148a1.148 1.148 0 1 0 0 2.3h10.336a1.148 1.148 0 1 1 0 2.3H1.148a1.148 1.148 0 1 0 0 2.3h2.527v3.445a1.148 1.148 0 0 0 1.148 1.148h2.309a4.4 4.4 0 0 0 8.628 0h11.66a4.4 4.4 0 0 0 8.628 0h2a1.148 1.148 0 0 0 1.152-1.158v-6.89c0-3.369-3.554-3.593-3.557-3.6H26.8a1.148 1.148 0 0 1-1.153-1.147V0H4.823a1.148 1.148 0 0 0-1.148 1.148v2.527H2.3a1.148 1.148 0 1 0 0 2.3zm25.139 11.335a2.105 2.105 0 1 1-3.594 1.493 2.106 2.106 0 0 1 3.594-1.493zm-20.288 0A2.105 2.105 0 1 1 9.34 18.8a2.106 2.106 0 0 1 3.594-1.493zm0 0",
    style: {
      fill: "#7c7c7c",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastDelivery);
export default __webpack_public_path__ + "static/media/fast-delivery.31754ff0c09514bf84a4a64c6c670a41.svg";
export { ForwardRef as ReactComponent };